import { format } from "timeago.js";
export default function (value: string | null | Date): string {
    return format(new Date(value || "now"));
}
